// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 115,
  H_DESKTOP: 115,
  H_DESKTOP_OFFSET: 60 - 16,
};

export const NAV = {
  W_VERTICAL: 280,
  W_MINI: 88,
};
